import React from 'react';

import { IconFacebook, IconInstagram, IconTwitter, IconYoutube } from './icons';
import { SocialIcon } from './social-icon';
import { SocialIconsContainer } from './styled';
import { ISocialIconsProps } from './types';

export const SocialIcons: React.FC<ISocialIconsProps> = props => {
  return (
    <SocialIconsContainer>
      <SocialIcon href={props.facebookUrl}>
        <IconFacebook aria-hidden="true" />
      </SocialIcon>
      <SocialIcon href={props.twitterUrl}>
        <IconTwitter aria-hidden="true" />
      </SocialIcon>
      <SocialIcon href={props.youtubeUrl}>
        <IconYoutube aria-hidden="true" />
      </SocialIcon>
      <SocialIcon href={props.instagramUrl}>
        <IconInstagram aria-hidden="true" />
      </SocialIcon>
    </SocialIconsContainer>
  );
};
